<template>
  <div class="gallery-item">
    <div class="credential-item" :style="{ marginLeft: `${level * 20}px` }">
      <div class="gallery-name">
        <CIcon name="cipFolderBlue" size="custom-size" :height="16" class="mr-2" />
        <strong>{{ gallery.name }}</strong>
      </div>

      <div v-if="!gallery.passive && gallery.username" class="credential-content">
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Username</translate>:
          </span>
          <div class="credential-value">{{ gallery.username }}</div>
          <CButton
            color="light"
            class="ml-2 btn-circle"
            @click="copyInClipboard(gallery.username, 'Username')"

          >
            <CIcon name="cipCopy" size="custom-size" :height="16" />
          </CButton>
        </div>
        <div class="credential-row">
          <span class="credential-label">
            <translate translate-context="ftp.credentials">Password</translate>:
          </span>
          <div class="credential-value">{{ gallery.password }}</div>
          <CButton
            color="light"
            class="ml-2 btn-circle"
            @click="copyInClipboard(gallery.password, 'Password')"

          >
             <CIcon name="cipCopy" size="custom-size" :height="16" />
          </CButton>
        </div>
      </div>

      <div v-if="gallery.passive" class="text-muted small">
        <translate translate-context="ftp.credentials">Passive gallery (no credentials)</translate>
      </div>
    </div>

    <!-- Sub-galleries (recursive) -->
    <div v-if="gallery.sub_galleries && gallery.sub_galleries.length > 0">
      <GalleryCredential
        v-for="subGallery in gallery.sub_galleries"
        :key="subGallery.id"
        :gallery="subGallery"
        :level="level + 1"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalleryCredential',

  props: {
    gallery: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>
.gallery-item {
  margin-bottom: 0.5rem;
}

.credential-item {
  background: #FAFAFA;
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 0.5rem;
}


.gallery-name {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 0.95rem;
}

.credential-content {
  padding-left: 1.5rem;
}

.credential-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.credential-row:last-child {
  margin-bottom: 0;
}


.credential-label {
  font-weight: 500;
  min-width: 100px;
}

.credential-value {
  border-radius: 6px;
  background: #FFF;
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.copy-btn {
  padding: 0.25rem 0.5rem;
  min-width: auto;
}
</style>
